import React from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import HomeHero from '../Components/home/HomeHero';
import HomeStats from '../Components/home/HomeStats';
import HomeOfferings from '../Components/home/HomeOfferings';
import HomeHighlights from '../Components/home/HomeHighlights';
import HomeSuite from '../Components/home/HomeSuite';
import HomeAppDownload from '../Components/home/HomeAppDownload';
import HomeMobileApp from '../Components/home/HomeMobileApp';
import HomeStories from '../Components/home/HomeStories';
import HomeWhy from '../Components/home/HomeWhy';
import HomeSecurity from '../Components/home/HomeSecurity';
import HomeTestimonials from '../Components/home/HomeTestimonials';
import HomeCta from '../Components/home/HomeCta';
import Seo from '../Components/Seo';
import { breadcrumbSchema, organizationSchema, softwareSchema, websiteSchema } from '../data/seo';
import '../assests/css/home.css';

function Home() {
  return (
    <div className="eduya-home">
      <Seo
        path="/"
        schema={[organizationSchema, websiteSchema, softwareSchema, breadcrumbSchema('/', 'School ERP')]}
      />
      <Header />
      <main>
        <HomeHero />
        <HomeStats />
        <HomeOfferings />
        <HomeHighlights />
        <HomeSuite />
        <HomeAppDownload />
        <HomeMobileApp />
        <HomeStories />
        <HomeWhy />
        <HomeSecurity />
        <HomeTestimonials />
        <HomeCta />
      </main>
      <Footer />
    </div>
  );
}

export default Home;
